import { render, staticRenderFns } from "./CompanyDetailsModal.vue?vue&type=template&id=4d9c38d0&"
import script from "./CompanyDetailsModal.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports